import { nanoid } from 'nanoid'
import { makeAutoObservable } from 'mobx'
import { type CallStore } from 'entities/Call'

export class SharedWorkerCallStore {
  private _generateTabId = nanoid(7)
  private _worker: SharedWorker | null = null

  constructor(private _callStore: CallStore) {
    makeAutoObservable(this)

    this._init()
  }

  private _init = async () => {
    if (typeof SharedWorker === 'function') {
      if (!this._worker) {
        this._worker = new SharedWorker('/shared_worker_call.js')

        this._worker.port.start()
        this._initEvents()
        this.sendIdTab()
        this.sentActiveCallTab()
      }
    } else {
      console.warn('SharedWorker is not supported in this browser')
    }
  }

  private _initEvents = () => {
    if (!this._worker) return

    window.addEventListener('beforeunload', this.closeTab)

    this._worker.port.onmessage = (e) => {
      const event = e.data.event

      if (event === 'send_incoming_call') {
        const value = e.data.data.value as boolean

        this._callStore.stopAudio(value)
      }
    }
  }

  sendIdTab = () => {
    if (!this._worker) return

    this._worker.port.postMessage({
      event: 'id_tab',
      value: this._generateTabId,
    })
  }

  sentActiveCallTab = () => {
    if (!this._worker) return

    this._worker.port.postMessage({
      event: 'active_call_tab',
      value: this._generateTabId,
    })
  }

  sendIncomingCall = () => {
    if (!this._worker) return

    this._worker.port.postMessage({
      event: 'send_incoming_call',
    })
  }

  closeTab = () => {
    if (!this._worker) return

    this._worker.port.postMessage({
      event: 'close',
    })
  }
}
